import {useEffect, useState} from 'react';
import { useFetchPostDataV2, setPath } from './useFetchData'
import {useQueryParams} from './useLocationData'
import articleMapping from '../data/mapping/pages/articleMapping';
import articleMockData from '../data/promotionArticle.json';
import articlePageRequest from '../data/requests/articlePageRequest.json';

const useArticle = (pagePath) => {
    const queryKey = 'articleDetail' + pagePath;
    const queryParams = useQueryParams();
    const isMockData = queryParams.get('useMockData') === 'true';
    const [articleQueryData, setArticleData] = useState('');
    const requestBody = setPath(articlePageRequest, pagePath) ;

    const { isLoading, error, data } = useFetchPostDataV2(queryKey, requestBody, isMockData);
    useEffect(() => {
      if (data && !isMockData) {
        const mappedData = articleMapping(data);
        setArticleData(mappedData);
      }
    }, [data, isMockData])

    if (isMockData) {
      return {
        error: false,
        isLoading: false,
        articleQueryData: articleMockData
      };
    }

    return  {
      error,
      isLoading,
      articleQueryData
    };
}

export default useArticle;
